import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import api from "../../services/api";
import { toast } from "react-toastify";
import { useUser } from "../../Context/UserProvider";
import { useLocation, useNavigate } from "react-router-dom";

const FundWithPaystack = () => {
  const navigate = useNavigate()
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const reference = queryParams.get('reference');


  const { setEspee, user } = useUser();
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    price: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const Loader = () => {
    return (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1300,
        }}
      >
        <CircularProgress size={60} thickness={4.5} />
      </Box>
    );
  };

  // confirmation

  useEffect(() => {
    if (reference) {
      setLoading(true)
      const formRef = new FormData();
      const paymentRef = sessionStorage.getItem("paystackPaymentRef");
      formRef.append("reference", paymentRef);
      api.payments
        .confirmPaystackFunding(formRef)
        .then((confirmRes) => {
          toast.success(confirmRes.data?.message);
          setFormValues({
            price: "",
          })
          sessionStorage.removeItem("paystackPaymentRef");
          api.campaign
            .getEspeeBalance()
            .then((res) => {
              setEspee(res?.data);
              navigate("/dashboard");
            })
            .catch((err) => console.log(err));
        })
        .catch((confirmErr) => {
          console.log("Error confirming payment:", confirmErr);
          toast.error(confirmErr.response.data?.message);
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [setEspee, reference,navigate ])

  const handleSubmit = (e) => {
    e.preventDefault();
    if (user.status === 'inactive') {
      toast.error('Please Contact Admin to activate your account')
      setLoading(false)
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append("amount", formValues.price);

    api.payments
      .paystackInitiate(formData)
      .then((res) => {
        const ref = res.data.data.reference;
        const url = res.data.data?.authorization_url;
        sessionStorage.setItem("paystackPaymentRef", ref);

        // Use window.open to open the payment link in a new tab
        window.location.href = url;
      })
      .catch((err) => {
        console.log("Error initiating payment:", err);
        setLoading(false);
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      {loading && <Loader />}
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          maxWidth: 400,
          margin: "0 auto",
          padding: 2,
          boxShadow: 3,
          borderRadius: 1,
          backgroundColor: "white",
        }}
      >
        <Typography variant="h5" component="h2" gutterBottom>
          Fund your Account with Naira
        </Typography>
        <TextField
          label="Amount in Naira"
          variant="outlined"
          name="price"
          value={formValues.price}
          onChange={handleInputChange}
          fullWidth
          required
        />
        <Button type="submit" variant="contained" color="primary">
          Submit
        </Button>
      </Box>
    </>
  );
};

export default FundWithPaystack;
